import { MENU_PATHS } from '@src/containers/App/TimeTracker/constants';
import { PATHS as ABSENCES_PATHS } from '@src/packages/absences/constants';
import { PATHS as ADDRESSES_PATHS } from '@src/packages/addresses/constants';
import { PATHS as CHECKPOINT_ROUTES_PATHS } from '@src/packages/checkpointRoutes/constants';
import { PATHS as DASHBOARD_PATHS } from '@src/packages/dashboard/constants';
import { PATHS as DOCUMENT_REQUESTS_PATHS } from '@src/packages/documentRequests/constants';
import { PATHS as EMERGENCY_PATHS } from '@src/packages/emergencies/constants';
import { PATHS as EVENT_TYPES_PATHS } from '@src/packages/eventTypes/constants';
import { PATHS as EVENTS_PATHS } from '@src/packages/events/constants';
import { PATHS as GROUPS_PATHS } from '@src/packages/groups/constants';
import { PATHS as HOLIDAYS_PATHS } from '@src/packages/holidays/constants';
import { PATHS as JOB_PATHS } from '@src/packages/jobs/constants';
import { PATHS as LOCATIONS_PATHS } from '@src/packages/locations/constants';
import { PATHS as MONITORING_PATHS } from '@src/packages/monitoring/constants';
import { PATHS as OPERATIONAL_PANEL_PATHS } from '@src/packages/operationalPanel/constants';
import { PATHS as OPERONDA_API_PATHS } from '@src/packages/operondaApi/constants';
import { PATHS as USER_POSITION_HISTORY_PATHS } from '@src/packages/reports/constants';
import { PATHS as SCHEDULES_PATHS } from '@src/packages/schedules/constants';
import { PATHS as SHIFTS_PATHS } from '@src/packages/shifts/constants';
import { PATHS as TRIGGERS_PATHS } from '@src/packages/triggers/constants';
import { PATHS as USERS_PATHS } from '@src/packages/users/constants';
import { PATHS as WORK_JOURNEY_PATHS } from '@src/packages/workJourney/constants';
import { PATHS as WORK_ORDERS_PATHS } from '@src/packages/workOrders/constants';
import { PATHS as WORK_TEMPLATES_PATHS } from '@src/packages/workTemplates/constants';
import { PATHS as WORKER_SCORE_PATHS } from '@src/packages/workerScore/constants';
import { PATHS as CONFIG_PATHS } from '@src/routes/config/constants';
import { PATHS as USER_PATHS } from '@src/routes/user/constants';

export const SIDEBAR_OPEN_KEYS_STORAGE_KEY = 'sidebarNavOpenKeys';

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebarNavCollapsed';

export const SIDEBAR_MENU_KEYS = {
  HOME: 'home',
  REALTIME_CONTROL: 'realtime-control',
  OPERATIONS: 'operations',
  PLANNING: 'planning',
  CONFIGURATION: 'configuration',
  OPERATIONAL_PANEL: 'operational-panel',
  TIMELINE: 'timeline',
  EMERGENCIES: 'emergencies',
  EMERGENCY_COMMAND_CENTER: 'emergency-command-center',
  EMERGENCY_MONITORING: 'emergency-monitoring',
  EMERGENCY_HISTORY: 'emergency-history',
  EMERGENCY_TYPES: 'emergency-types',
  EMERGENCY_INTEGRATIONS: 'emergency-integrations',
  WORK_ORDERS: 'work-orders',
  WORK_JOURNEY_REAL_TIME: 'work-journey-real-time',
  ACTIVE_SCHEDULES: 'share',
  ACTIVE_USERS: 'contacts',
  METRICS: 'show_chart',
  POSITION_HISTORY: 'history',
  LOCATION_ALERTS: 'motion_sensor_urgent',
  DOCUMENT_REQUESTS: 'document-requests',
  SCHEDULE_REPORT: 'schedule-report',
  TASK_REPORT: 'task-report',
  OPERATION_REPORT: 'operation-report',
  WORKER_SCORE_NOTES: 'worker-score-notes',
  WORK_JOURNEY: 'work-journey',
  WORK_JOURNEY_MANAGEMENT: 'work-journey-management',
  WORK_SHIFTS: 'work_shifts',
  ROUTES: 'route',
  CHECKPOINT_ROUTES_REPORT: 'checkpoint-routes-report',
  CHECKPOINT_ROUTES_REALTIME: 'sidebar.menu.checkpoint.routes.realtime',
  CHECKPOINT_ROUTES_SCHEDULED: 'checkpoint-routes-scheduled',
  CHECKPOINT_ROUTES_CREATE: 'checkpoint-routes-create',
  SCHEDULES: 'calendar_today',
  WORK_TEMPLATES: 'task_alt',
  TIME_TRACKER: 'timeTracker',
  OWN_TIME_TRACKER: 'ownTimeTracker',
  ATTENDANCE_REPORT: 'attendance-report',
  DAILY_REPORT: 'daily-report',
  HOLIDAYS_REPORT: 'holidays-report',
  MODIFICATIONS_REPORT: 'modifications-report',
  ISSUES_REPORT: 'issues-report',
  HASH: 'hash',
  SIGNATURE_DOCUMENTS: 'signature-documents',
  FORMS: 'article',
  TRIGGERS: 'flash_on',
  LOCATIONS: 'location_on',
  ORGANIZATION: 'organization',
  ORGANIZATION_INFO: 'business',
  DIVISIONS: 'divisions',
  JOBS: 'positions',
  OPTION_LISTS: 'option-lists',
  COST_CENTERS: 'cost-centers',

  GROUPS: 'groups',
  USERS: 'group',
  ADDRESSES: 'addresses',
  HOLIDAYS: 'holidays',
  ABSENCES: 'absences',
  OPERONDA_API: 'operonda-api',
  AUDIT_LOGS: 'audit-logs',
} as const;

export const SIDEBAR_SECTION_KEYS = [
  SIDEBAR_MENU_KEYS.REALTIME_CONTROL,
  SIDEBAR_MENU_KEYS.OPERATIONS,
  SIDEBAR_MENU_KEYS.PLANNING,
  SIDEBAR_MENU_KEYS.CONFIGURATION,
] as const;

export const SIDEBAR_SECTION_LABEL_IDS = {
  [SIDEBAR_MENU_KEYS.REALTIME_CONTROL]: 'sidebar.nav.realtimeControl',
  [SIDEBAR_MENU_KEYS.OPERATIONS]: 'sidebar.nav.operations',
  [SIDEBAR_MENU_KEYS.PLANNING]: 'sidebar.nav.planning',
  [SIDEBAR_MENU_KEYS.CONFIGURATION]: 'sidebar.nav.configuration',
} as const;

export const TIME_TRACKER_GATED_KEYS = [
  SIDEBAR_MENU_KEYS.TIME_TRACKER,
  SIDEBAR_MENU_KEYS.WORK_SHIFTS,
  SIDEBAR_MENU_KEYS.WORK_JOURNEY,
  SIDEBAR_MENU_KEYS.WORK_JOURNEY_MANAGEMENT,
  SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
] as const;

const REALTIME_CONTROL_ITEM_KEYS = [
  SIDEBAR_MENU_KEYS.OPERATIONAL_PANEL,
  SIDEBAR_MENU_KEYS.TIMELINE,
  SIDEBAR_MENU_KEYS.ACTIVE_SCHEDULES,
  SIDEBAR_MENU_KEYS.WORK_ORDERS,
  SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_REALTIME,
  SIDEBAR_MENU_KEYS.WORK_JOURNEY_REAL_TIME,
  SIDEBAR_MENU_KEYS.EMERGENCY_COMMAND_CENTER,
  SIDEBAR_MENU_KEYS.EMERGENCY_MONITORING,
  SIDEBAR_MENU_KEYS.ACTIVE_USERS,
  SIDEBAR_MENU_KEYS.LOCATION_ALERTS,
] as const;

const OPERATIONS_ITEM_KEYS = [
  SIDEBAR_MENU_KEYS.OPERATION_REPORT,
  SIDEBAR_MENU_KEYS.WORKER_SCORE_NOTES,
  SIDEBAR_MENU_KEYS.SCHEDULE_REPORT,
  SIDEBAR_MENU_KEYS.TASK_REPORT,
  SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_REPORT,
  SIDEBAR_MENU_KEYS.METRICS,
  SIDEBAR_MENU_KEYS.WORK_JOURNEY_MANAGEMENT,
  SIDEBAR_MENU_KEYS.ABSENCES,
  SIDEBAR_MENU_KEYS.POSITION_HISTORY,
  SIDEBAR_MENU_KEYS.EMERGENCY_HISTORY,
  SIDEBAR_MENU_KEYS.DOCUMENT_REQUESTS,
  SIDEBAR_MENU_KEYS.TIME_TRACKER,
  SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
  SIDEBAR_MENU_KEYS.ATTENDANCE_REPORT,
  SIDEBAR_MENU_KEYS.DAILY_REPORT,
  SIDEBAR_MENU_KEYS.HOLIDAYS_REPORT,
  SIDEBAR_MENU_KEYS.MODIFICATIONS_REPORT,
  SIDEBAR_MENU_KEYS.ISSUES_REPORT,
  SIDEBAR_MENU_KEYS.HASH,
  SIDEBAR_MENU_KEYS.SIGNATURE_DOCUMENTS,
] as const;

const PLANNING_ITEM_KEYS = [
  SIDEBAR_MENU_KEYS.SCHEDULES,
  SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_SCHEDULED,
  SIDEBAR_MENU_KEYS.WORK_TEMPLATES,
  SIDEBAR_MENU_KEYS.WORK_JOURNEY,
  SIDEBAR_MENU_KEYS.WORK_SHIFTS,
  SIDEBAR_MENU_KEYS.TRIGGERS,
  SIDEBAR_MENU_KEYS.FORMS,
  SIDEBAR_MENU_KEYS.LOCATIONS,
] as const;

const CONFIGURATION_ITEM_KEYS = [
  SIDEBAR_MENU_KEYS.ORGANIZATION,
  SIDEBAR_MENU_KEYS.DIVISIONS,
  SIDEBAR_MENU_KEYS.USERS,
  SIDEBAR_MENU_KEYS.GROUPS,
  SIDEBAR_MENU_KEYS.JOBS,
  SIDEBAR_MENU_KEYS.HOLIDAYS,
  SIDEBAR_MENU_KEYS.ADDRESSES,
  SIDEBAR_MENU_KEYS.OPERONDA_API,
  SIDEBAR_MENU_KEYS.EMERGENCY_TYPES,
  SIDEBAR_MENU_KEYS.EMERGENCY_INTEGRATIONS,
  SIDEBAR_MENU_KEYS.AUDIT_LOGS,
] as const;

const toSectionMap = (
  keys: readonly string[],
  section: string,
): Record<string, string> => Object.fromEntries(keys.map(key => [key, section]));

export const MENU_KEY_TO_SECTION: Record<string, string> = {
  ...toSectionMap(REALTIME_CONTROL_ITEM_KEYS, SIDEBAR_MENU_KEYS.REALTIME_CONTROL),
  ...toSectionMap(OPERATIONS_ITEM_KEYS, SIDEBAR_MENU_KEYS.OPERATIONS),
  ...toSectionMap(PLANNING_ITEM_KEYS, SIDEBAR_MENU_KEYS.PLANNING),
  ...toSectionMap(CONFIGURATION_ITEM_KEYS, SIDEBAR_MENU_KEYS.CONFIGURATION),
};

export const NESTED_PARENT_BY_KEY: Record<string, string | readonly string[]> = {
  [SIDEBAR_MENU_KEYS.ATTENDANCE_REPORT]: [
    SIDEBAR_MENU_KEYS.TIME_TRACKER,
    SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
  ],
  [SIDEBAR_MENU_KEYS.DAILY_REPORT]: [
    SIDEBAR_MENU_KEYS.TIME_TRACKER,
    SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
  ],
  [SIDEBAR_MENU_KEYS.HOLIDAYS_REPORT]: [
    SIDEBAR_MENU_KEYS.TIME_TRACKER,
    SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
  ],
  [SIDEBAR_MENU_KEYS.MODIFICATIONS_REPORT]: [
    SIDEBAR_MENU_KEYS.TIME_TRACKER,
    SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER,
  ],
  [SIDEBAR_MENU_KEYS.ISSUES_REPORT]: SIDEBAR_MENU_KEYS.TIME_TRACKER,
  [SIDEBAR_MENU_KEYS.HASH]: [SIDEBAR_MENU_KEYS.TIME_TRACKER, SIDEBAR_MENU_KEYS.OWN_TIME_TRACKER],
};

type PathMatcher = {
  path: string;
  key: string | null;
};

const pathWithoutRouteParams = (routePath: string): string => {
  const paramIndex = routePath.indexOf('/:');
  return paramIndex === -1 ? routePath : routePath.slice(0, paramIndex);
};

export const MENU_PATH_MATCHERS: PathMatcher[] = [
  { path: USER_PATHS.PROFILE, key: null },
  { path: `${USERS_PATHS.BASE_URL}/notifications`, key: null },
  { path: EMERGENCY_PATHS.MONITORING, key: SIDEBAR_MENU_KEYS.EMERGENCY_MONITORING },
  { path: EMERGENCY_PATHS.HISTORY, key: SIDEBAR_MENU_KEYS.EMERGENCY_HISTORY },
  { path: EMERGENCY_PATHS.TYPES, key: SIDEBAR_MENU_KEYS.EMERGENCY_TYPES },
  { path: EMERGENCY_PATHS.INTEGRATIONS, key: SIDEBAR_MENU_KEYS.EMERGENCY_INTEGRATIONS },
  { path: EMERGENCY_PATHS.COMMAND_CENTER, key: SIDEBAR_MENU_KEYS.EMERGENCY_COMMAND_CENTER },
  { path: WORK_JOURNEY_PATHS.REAL_TIME, key: SIDEBAR_MENU_KEYS.WORK_JOURNEY_REAL_TIME },
  { path: WORK_JOURNEY_PATHS.WORK_JOURNEY_MANAGEMENT, key: SIDEBAR_MENU_KEYS.WORK_JOURNEY_MANAGEMENT },
  { path: WORK_JOURNEY_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.WORK_JOURNEY },
  { path: DASHBOARD_PATHS.ACTIVE_CHECKPOINT_ROUTES_DASHBOARD, key: SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_REALTIME },
  { path: DASHBOARD_PATHS.CHECKPOINT_ROUTES, key: SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_REPORT },
  { path: DASHBOARD_PATHS.OPERATION_REPORT, key: SIDEBAR_MENU_KEYS.OPERATION_REPORT },
  { path: DASHBOARD_PATHS.ACTIVE_SCHEDULES, key: SIDEBAR_MENU_KEYS.ACTIVE_SCHEDULES },
  { path: DASHBOARD_PATHS.ACTIVE_USER_DASHBOARD, key: SIDEBAR_MENU_KEYS.ACTIVE_USERS },
  { path: DASHBOARD_PATHS.EVENTS, key: SIDEBAR_MENU_KEYS.METRICS },
  { path: DASHBOARD_PATHS.SCHEDULES, key: SIDEBAR_MENU_KEYS.SCHEDULE_REPORT },
  { path: DASHBOARD_PATHS.TASKS, key: SIDEBAR_MENU_KEYS.TASK_REPORT },
  { path: CHECKPOINT_ROUTES_PATHS.CREATE_CHECKPOINT_ROUTE, key: SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_SCHEDULED },
  { path: CHECKPOINT_ROUTES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.CHECKPOINT_ROUTES_SCHEDULED },
  { path: USER_POSITION_HISTORY_PATHS.USER_POSITIONS_HISTORY, key: SIDEBAR_MENU_KEYS.POSITION_HISTORY },
  { path: MONITORING_PATHS.LOCATION_ALERTS, key: SIDEBAR_MENU_KEYS.LOCATION_ALERTS },
  { path: DOCUMENT_REQUESTS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.DOCUMENT_REQUESTS },
  { path: OPERATIONAL_PANEL_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.OPERATIONAL_PANEL },
  { path: EVENTS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.TIMELINE },
  { path: WORK_ORDERS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.WORK_ORDERS },
  { path: SHIFTS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.WORK_SHIFTS },
  { path: SCHEDULES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.SCHEDULES },
  { path: WORK_TEMPLATES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.WORK_TEMPLATES },
  { path: WORKER_SCORE_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.WORKER_SCORE_NOTES },
  { path: MENU_PATHS.ATTENDANCE_REPORT, key: SIDEBAR_MENU_KEYS.ATTENDANCE_REPORT },
  { path: MENU_PATHS.DAILY, key: SIDEBAR_MENU_KEYS.DAILY_REPORT },
  { path: MENU_PATHS.HOLIDAYS, key: SIDEBAR_MENU_KEYS.HOLIDAYS_REPORT },
  { path: MENU_PATHS.MODIFICATIONS, key: SIDEBAR_MENU_KEYS.MODIFICATIONS_REPORT },
  { path: MENU_PATHS.ISSUES, key: SIDEBAR_MENU_KEYS.ISSUES_REPORT },
  { path: MENU_PATHS.HASH, key: SIDEBAR_MENU_KEYS.HASH },
  { path: EVENT_TYPES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.FORMS },
  { path: TRIGGERS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.TRIGGERS },
  { path: LOCATIONS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.LOCATIONS },
  { path: CONFIG_PATHS.ORGANIZATION, key: SIDEBAR_MENU_KEYS.ORGANIZATION },
  { path: CONFIG_PATHS.AUDIT_LOGS, key: SIDEBAR_MENU_KEYS.AUDIT_LOGS },
  { path: pathWithoutRouteParams(CONFIG_PATHS.DIVISION_FORM), key: SIDEBAR_MENU_KEYS.DIVISIONS },
  { path: CONFIG_PATHS.DIVISIONS, key: SIDEBAR_MENU_KEYS.DIVISIONS },
  { path: JOB_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.JOBS },
  { path: GROUPS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.GROUPS },
  { path: ADDRESSES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.ADDRESSES },
  { path: HOLIDAYS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.HOLIDAYS },
  { path: ABSENCES_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.ABSENCES },
  { path: OPERONDA_API_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.OPERONDA_API },
  { path: USERS_PATHS.BASE_URL, key: SIDEBAR_MENU_KEYS.USERS },
];
